import { render, staticRenderFns } from "./SyncLogsTab.vue?vue&type=template&id=052cfb50&scoped=true";
import script from "./SyncLogsTab.vue?vue&type=script&lang=jsx";
export * from "./SyncLogsTab.vue?vue&type=script&lang=jsx";
import style0 from "./SyncLogsTab.vue?vue&type=style&index=0&id=052cfb50&prod&scoped=true&lang=less";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "052cfb50", null);
export default component.exports;